import type { ReactNode } from "react";
import "./ColorSwatch.scss";
import classNames from "classnames";

interface Properties {
  color: string | undefined;
}

export default function ColorSwatch(props: Properties): ReactNode {
  return (
    <div
      style={{ backgroundColor: props.color }}
      className={classNames(
        "color-swatch",
        props.color === undefined && "no-color",
      )}
    />
  );
}
